<div class="modal-header">
    <h4 class="modal-title">{{'Modals.captchaTitle' | translate}}</h4>
</div>
<div class="captcha-wrapper">
    <div id="recaptcha-container"></div>
</div>  